import { render, staticRenderFns } from "./discuss-list.vue?vue&type=template&id=89f8760a&"
import script from "./discuss-list.vue?vue&type=script&lang=js&"
export * from "./discuss-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports